import React from "react";
import style from "./Cards.module.css";
import img1 from "../../../assets/contenido/cardcont1.png";
import img2 from "../../../assets/contenido/cardcont2.png";
import img3 from "../../../assets/contenido/cardcont3.png";
import { ContentCard } from "./ContentCard";
import { useHistory } from "react-router-dom";

export const Cards = () => {
  let history = useHistory();

  function handler1() {
    history.push("/ContentExp/1");
  }

  function handler2() {
    history.push("/ContentExp/2");
  }

  function handler3() {
    history.push("/ContentExp/3");
  }

  const article1 = {
    img: img1,
    text: "Maxwell's equations—the foundation of classical electromagnetism—describe light as a wave that moves with a characteristic velocity. The modern view is that light needs no medium of transmission, but Maxwell and his contemporaries were convinced that light waves were propagated in a medium...",
    title: `Las velas como regalo`,
  };

  const article2 = {
    img: img2,
    text: "Maxwell's equations—the foundation of classical electromagnetism—describe light as a wave that moves with a characteristic velocity. The modern view is that light needs no medium of transmission, but Maxwell and his contemporaries were convinced that light waves were propagated in a medium...",
    title: "Velas como decoración",
  };

  const article3 = {
    img: img3,
    text: "Maxwell's equations—the foundation of classical electromagnetism—describe light as a wave that moves with a characteristic velocity. The modern view is that light needs no medium of transmission, but Maxwell and his contemporaries were convinced that light waves were propagated in a medium...",
    title: "Como cortar tu mecha",
  };

  return (
    <div className={style.container}>
      <ContentCard
        imagen={article1.img}
        title={article1.title}
        text={article1.text}
        action={handler1}
      >
        {" "}
      </ContentCard>
      <ContentCard
        imagen={article2.img}
        title={article2.title}
        text={article2.text}
        action={handler2}
      >
        {" "}
      </ContentCard>
      <ContentCard
        imagen={article3.img}
        title={article3.title}
        text={article3.text}
        action={handler3}
      >
        {" "}
      </ContentCard>
    </div>
  );
};
